/**
 * Converts a single graphql PrescriptionDownload object to a local PrescriptionDownload object,
 * converting strings to dates and "fullName" null to undefined.
 */ const toPrescriptionDownload = ({ downloadUrl , expiryDate , fullName , id , isValid , issueDate , prescriptionType ,  })=>({
        id,
        downloadUrl,
        expiryDate: new Date(expiryDate),
        fullName: fullName !== null && fullName !== void 0 ? fullName : undefined,
        isValid,
        issueDate: new Date(issueDate),
        prescriptionType
    })
;
/**
 * Maps an array of graphql PrescriptionDownload objects to local PrescriptionDownload objects,
 * filtering out any duplicates. Uniqueness is determined based on the value of "fullName" and
 * "prescriptionType".
 */ const toPrescriptionDownloads = (prescriptions)=>{
    return prescriptions.filter((prescription)=>{
        // If there is another prescription with the same "prescriptionType" and "fullName"
        // select the one with latest "issueDate"
        return !prescriptions.filter((ps)=>ps.id !== prescription.id && ps.prescriptionType === prescription.prescriptionType && ps.fullName === prescription.fullName && ps.issueDate > prescription.issueDate
        ).length;
    }).map(toPrescriptionDownload);
};

export { toPrescriptionDownload, toPrescriptionDownloads };
//# sourceMappingURL=prescription-downloads.js.map
